/** The name a subscription is shown with: the user's own, or the merchant's. */
export const getSubscriptionName = (subscription) => subscription.customName || subscription.merchantInfo?.displayName || '';
